export default __webpack_public_path__ + "static/media/UNIDX.b5cdc4dd.png";